(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 21964:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ DenomInput; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82140);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32735);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33090);
/* harmony import */ var _components_DenomIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32685);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57333);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["denom", "value", "onChange", "type", "defaultValue"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function DenomInput(_ref) {
  var denom = _ref.denom,
      value = _ref.value,
      onChange = _ref.onChange,
      type = _ref.type,
      defaultValue = _ref.defaultValue,
      props = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var handleChange = function handleChange(values) {
    onChange(values.floatValue);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .InputGroup */ .B, {
    children: [denom && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .InputLeftElement */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_DenomIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        denomInfo: denom
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_number_format__WEBPACK_IMPORTED_MODULE_6__/* .NumericFormat */ .h3, _objectSpread({
      pl: denom ? 10 : undefined,
      placeholder: "Enter amount",
      customInput: _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Input */ .I,
      allowNegative: false,
      onValueChange: handleChange,
      value: value,
      defaultValue: defaultValue,
      thousandSeparator: ","
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .InputRightElement */ .x, {
      textStyle: "body-xs",
      w: "min-content",
      p: 3,
      children: denom === null || denom === void 0 ? void 0 : denom.name
    })]
  });
}

/***/ }),

/***/ 39233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Radio; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34292);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function Radio(_ref) {
  var children = _ref.children,
      props = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .HStack */ .U, _objectSpread(_objectSpread({
    bg: "abyss.200",
    w: "max-content",
    borderRadius: "2xl",
    px: 1,
    py: 1,
    spacing: 1
  }, props), {}, {
    children: children
  }));
}

/***/ }),

/***/ 9126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RadioCard; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58972);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97702);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57747);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71293);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["disabledMessage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




function RadioCard(_ref) {
  var disabledMessage = _ref.disabledMessage,
      props = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var children = props.children,
      borderRadius = props.borderRadius,
      isDisabled = props.isDisabled;

  var _useRadio = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .useRadio */ .x)(props),
      getInputProps = _useRadio.getInputProps,
      getCheckboxProps = _useRadio.getCheckboxProps,
      htmlProps = _useRadio.htmlProps,
      getLabelProps = _useRadio.getLabelProps;

  var input = getInputProps();
  var checkbox = getCheckboxProps();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Tooltip */ .u, {
    label: isDisabled ? disabledMessage : '',
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, _objectSpread(_objectSpread({
      as: "label"
    }, htmlProps), {}, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread({}, input)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, _objectSpread(_objectSpread({}, checkbox), {}, {
        cursor: "pointer",
        px: 2,
        _checked: {
          bg: 'blue.200',
          color: 'navy'
        },
        borderRadius: borderRadius || '2xl',
        _focus: {
          boxShadow: 'outline'
        },
        _disabled: {
          opacity: 0.4,
          cursor: 'not-allowed'
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, _objectSpread(_objectSpread({}, getLabelProps()), {}, {
          children: children
        }))
      }))]
    }))
  });
}

/***/ }),

/***/ 18428:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ SummaryAgreementForm; }
/* harmony export */ });
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82730);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55281);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71293);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93108);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85970);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26105);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73064);
/* harmony import */ var _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52597);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82580);
/* harmony import */ var _components_Submit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9685);
/* harmony import */ var _components_TermsModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37930);
/* harmony import */ var _AgreementCheckbox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);









function SummaryAgreementForm(_ref) {
  var isError = _ref.isError,
      error = _ref.error,
      onSubmit = _ref.onSubmit,
      isDisabled = _ref.isDisabled;

  var _useDisclosure = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .useDisclosure */ .q)(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var validate = function validate(values) {
    if (!values.acceptedAgreement) {
      return {
        acceptedAgreement: 'You must accept the terms and conditions before continuing.'
      };
    }

    return {};
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Formik */ .J9, {
    initialValues: {
      acceptedAgreement: false
    },
    validate: validate,
    onSubmit: onSubmit,
    children: function children(_ref2) {
      var acceptedAgreement = _ref2.values.acceptedAgreement;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(formik__WEBPACK_IMPORTED_MODULE_7__/* .Form */ .l0, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Stack */ .K, {
          spacing: 4,
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_AgreementCheckbox__WEBPACK_IMPORTED_MODULE_4__/* .AgreementCheckbox */ .k, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
              textStyle: "body-xs",
              children: ["I have read and agree to be bound by the", ' ', /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .Button */ .z, {
                textDecoration: "underline",
                fontWeight: "normal",
                size: "xs",
                display: "inline-flex",
                colorScheme: "blue",
                variant: "unstyled",
                onClick: onOpen,
                children: "CALC Terms & Conditions."
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_11__/* .FormControl */ .NI, {
            isInvalid: isError,
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Submit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              w: "full",
              type: "submit",
              rightIcon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
                as: _fusion_icons_react_interface__WEBPACK_IMPORTED_MODULE_1__/* .CheckedIcon */ .YJ9,
                stroke: "navy"
              }),
              isDisabled: isDisabled || !acceptedAgreement,
              children: "Confirm"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .FormErrorMessage */ .J1, {
              children: ["Failed to create strategy (Reason: ", error === null || error === void 0 ? void 0 : error.message, ")"]
            })]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_TermsModal__WEBPACK_IMPORTED_MODULE_3__/* .TermsModal */ .X, {
            showCheckbox: false,
            isOpen: isOpen,
            onClose: onClose
          })]
        })
      });
    }
  });
}

/***/ }),

/***/ 2248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18459);

var simpleDcaInSteps = [{
  href: '/',
  title: src_constants__WEBPACK_IMPORTED_MODULE_0__/* .contentData.dcaIn.assets.title */ .fS.dcaIn.assets.title
}, {
  href: '/',
  title: 'Strategy Created!',
  noJump: true,
  successPage: true
}];
/* harmony default export */ __webpack_exports__["Z"] = (simpleDcaInSteps);

/***/ }),

/***/ 58112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ checkSwapAmountValue; }
/* harmony export */ });
/* harmony import */ var _format_formatFiat__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50215);
/* harmony import */ var _chains__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87038);


function checkSwapAmountValue(chainId, swapAmount, price) {
  if (false) {}
  var swapAmountValue = swapAmount * price;
  var minimumSwapAmount = (0,_chains__WEBPACK_IMPORTED_MODULE_1__/* .getChainMinimumSwapValue */ .Jd)(chainId);

  if (!(swapAmountValue >= minimumSwapAmount)) {
    throw new Error("Minimum swap amount must be greater than ".concat((0,_format_formatFiat__WEBPACK_IMPORTED_MODULE_0__/* .formatFiat */ .M)(minimumSwapAmount)));
  }
}

/***/ }),

/***/ 84333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ getTimeSaved; }
/* harmony export */ });
/* harmony import */ var _utils_totalExecutions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66260);

var TIME_SAVED_PER_SWAP = 10;
function getTimeSaved(deposit, swapAmount) {
  return (0,_utils_totalExecutions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deposit, swapAmount) * TIME_SAVED_PER_SWAP;
}

/***/ }),

/***/ 67039:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "I": function() { return /* binding */ useCalcSigningClient; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(5403);
// EXTERNAL MODULE: ./src/hooks/useConfig.ts
var useConfig = __webpack_require__(79149);
// EXTERNAL MODULE: ./src/hooks/useChainId.ts
var useChainId = __webpack_require__(12680);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./src/hooks/useCalcSigningClient/getClient/clients/cosmos/index.ts + 3 modules
var cosmos = __webpack_require__(77521);
;// CONCATENATED MODULE: ./src/hooks/useCalcSigningClient/getClient/index.ts

function getClient(chainConfig, fetchedConfig, signingClient) {
  return signingClient && fetchedConfig && (0,cosmos/* getCosmosCalcSigningClient */.A)(signingClient, chainConfig, fetchedConfig);
}
;// CONCATENATED MODULE: ./src/hooks/useCalcSigningClient/index.ts


var _excluded = ["data"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






function useCalcSigningClient() {
  var _useChainId = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId.chainId,
      chainConfig = _useChainId.chainConfig;

  var fetchedConfig = (0,useConfig/* useConfig */.Z)();

  var _useWallet = (0,useWallet/* useWallet */.O)(),
      connected = _useWallet.connected,
      getSigningClient = _useWallet.getSigningClient;

  var _useQuery = (0,useQuery/* useQuery */.a)(['signingCosmWasmClient', chainId], getSigningClient, {
    enabled: !!chainId && connected,
    meta: {
      errorMessage: 'Error fetching signing client'
    }
  }),
      signingClient = _useQuery.data,
      other = (0,objectWithoutProperties/* default */.Z)(_useQuery, _excluded);

  return _objectSpread({
    calcSigningClient: getClient(chainConfig, fetchedConfig, signingClient)
  }, other);
}

/***/ }),

/***/ 70302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ handleError; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _sentry_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64487);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



function getSentryCreateVaultTags(createVaultContext) {
  var _createVaultContext$t, _createVaultContext$t2;

  return _objectSpread(_objectSpread({}, createVaultContext), {}, {
    initialDenom: createVaultContext.initialDenom.name,
    resultingDenom: createVaultContext.resultingDenom.name,
    timeInterval: "".concat(createVaultContext.timeInterval.increment, " ").concat(createVaultContext.timeInterval.interval),
    timeTrigger: "".concat((_createVaultContext$t = createVaultContext.timeTrigger) === null || _createVaultContext$t === void 0 ? void 0 : _createVaultContext$t.startDate, " ").concat((_createVaultContext$t2 = createVaultContext.timeTrigger) === null || _createVaultContext$t2 === void 0 ? void 0 : _createVaultContext$t2.startTime),
    destinationConfig: JSON.stringify(createVaultContext.destinationConfig),
    swapAdjustment: JSON.stringify(createVaultContext.swapAdjustment)
  });
}

function handleError(createVaultContext) {
  return function (error) {
    if (error instanceof Error) {
      if (!error.message.includes('Request rejected')) {
        _sentry_react__WEBPACK_IMPORTED_MODULE_1__/* .captureException */ .Tb(error, {
          tags: getSentryCreateVaultTags(createVaultContext)
        });
        throw new Error(error.message);
      }

      throw new Error('Transaction cancelled');
    }

    throw new Error('Unknown error');
  };
}

/***/ }),

/***/ 11247:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useCreateVaultDca; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _hooks_useWallet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5403);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48228);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47134);
/* harmony import */ var _hooks_useCalcSigningClient__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67039);
/* harmony import */ var _helpers_checkSwapAmountValue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58112);
/* harmony import */ var _helpers_createStrategyFeeInTokens__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18081);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12680);
/* harmony import */ var _hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78719);
/* harmony import */ var _hooks_useCreateVault_useTrackCreateVault__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61310);
/* harmony import */ var _handleError__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70302);



/* eslint-disable consistent-return */











var useCreateVaultDca = function useCreateVaultDca() {
  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_7__/* .useChainId */ .x)(),
      chainId = _useChainId.chainId;

  var _useStrategyInfo = (0,_hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_3__/* .useStrategyInfo */ .R0)(),
      transactionType = _useStrategyInfo.transactionType;

  var _useCalcSigningClient = (0,_hooks_useCalcSigningClient__WEBPACK_IMPORTED_MODULE_4__/* .useCalcSigningClient */ .I)(),
      calcSigningClient = _useCalcSigningClient.calcSigningClient;

  var _useWallet = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_1__/* .useWallet */ .O)(),
      address = _useWallet.address;

  var _useFiatPrices = (0,_hooks_useFiatPrices__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(),
      fiatPrices = _useFiatPrices.fiatPrices;

  var track = (0,_hooks_useCreateVault_useTrackCreateVault__WEBPACK_IMPORTED_MODULE_9__/* .useTrackCreateVault */ .T)();
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__/* .useMutation */ .D)( /*#__PURE__*/function () {
    var _ref2 = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
      var _state$initialDenom, _fiatPrices$state$ini, _state$initialDenom2;

      var state, reinvestStrategyData, price, _state$initialDenom3, createVaultContext, fee, createResponse;

      return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = _ref.state, reinvestStrategyData = _ref.reinvestStrategyData;

              if (state) {
                _context.next = 3;
                break;
              }

              throw new Error('No state');

            case 3:
              if (!(!(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isNil)(state.reinvestStrategy) && !(0,lodash__WEBPACK_IMPORTED_MODULE_2__.isEmpty)(state.reinvestStrategy) && !reinvestStrategyData)) {
                _context.next = 5;
                break;
              }

              throw new Error('Invalid reinvest strategy.');

            case 5:
              if (calcSigningClient) {
                _context.next = 7;
                break;
              }

              throw Error('Invalid client');

            case 7:
              if (state.initialDenom) {
                _context.next = 9;
                break;
              }

              throw Error('Invalid initial denom');

            case 9:
              price = ((_state$initialDenom = state.initialDenom) === null || _state$initialDenom === void 0 ? void 0 : _state$initialDenom.coingeckoId) && (fiatPrices === null || fiatPrices === void 0 ? void 0 : (_fiatPrices$state$ini = fiatPrices[(_state$initialDenom2 = state.initialDenom) === null || _state$initialDenom2 === void 0 ? void 0 : _state$initialDenom2.coingeckoId]) === null || _fiatPrices$state$ini === void 0 ? void 0 : _fiatPrices$state$ini.usd);

              if (price) {
                _context.next = 12;
                break;
              }

              throw Error("Coingecko listing is required for ".concat((_state$initialDenom3 = state.initialDenom) === null || _state$initialDenom3 === void 0 ? void 0 : _state$initialDenom3.name, " in order to evaluate the minimum viable swap amount"));

            case 12:
              if (address) {
                _context.next = 14;
                break;
              }

              throw new Error('No sender address');

            case 14:
              (0,_helpers_checkSwapAmountValue__WEBPACK_IMPORTED_MODULE_5__/* .checkSwapAmountValue */ .u)(chainId, state.swapAmount, price);

              if (state.resultingDenom) {
                _context.next = 17;
                break;
              }

              throw new Error('Invalid resulting denom');

            case 17:
              createVaultContext = {
                initialDenom: state.initialDenom,
                resultingDenom: state.resultingDenom,
                timeInterval: {
                  interval: state.executionInterval,
                  increment: state.executionIntervalIncrement
                },
                timeTrigger: {
                  startDate: state.startDate,
                  startTime: state.purchaseTime
                },
                startPrice: state.startPrice || undefined,
                swapAmount: state.swapAmount,
                route: state.route,
                priceThreshold: state.priceThresholdValue || undefined,
                transactionType: transactionType,
                slippageTolerance: state.slippageTolerance,
                destinationConfig: {
                  autoStakeValidator: state.autoStakeValidator || undefined,
                  autoCompoundStakingRewards: state.autoCompoundStakingRewards,
                  recipientAccount: state.recipientAccount || undefined,
                  yieldOption: state.yieldOption || undefined,
                  reinvestStrategyId: state.reinvestStrategy || undefined,
                  senderAddress: address
                }
              };
              fee = (0,_helpers_createStrategyFeeInTokens__WEBPACK_IMPORTED_MODULE_6__/* .createStrategyFeeInTokens */ .y)(price, state.initialDenom).toFixed(0);
              _context.prev = 19;
              _context.next = 22;
              return calcSigningClient.createStrategy(address, state.initialDeposit, fee, createVaultContext);

            case 22:
              createResponse = _context.sent;
              track();
              return _context.abrupt("return", createResponse);

            case 27:
              _context.prev = 27;
              _context.t0 = _context["catch"](19);
              (0,_handleError__WEBPACK_IMPORTED_MODULE_12__/* .handleError */ .S)(createVaultContext)(_context.t0);

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[19, 27]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
};

/***/ }),

/***/ 61310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useTrackCreateVault; }
/* harmony export */ });
/* harmony import */ var _hooks_useWallet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5403);
/* harmony import */ var _hooks_useChainId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12680);
/* harmony import */ var _hooks_useAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39747);
/* harmony import */ var _hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47134);




function useTrackCreateVault() {
  var _useChainId = (0,_hooks_useChainId__WEBPACK_IMPORTED_MODULE_1__/* .useChainId */ .x)(),
      chain = _useChainId.chainId;

  var _useStrategyInfo = (0,_hooks_useStrategyInfo__WEBPACK_IMPORTED_MODULE_2__/* .useStrategyInfo */ .R0)(),
      formName = _useStrategyInfo.formName;

  var _useWallet = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_0__/* .useWallet */ .O)(),
      senderAddress = _useWallet.address;

  var _useWallet2 = (0,_hooks_useWallet__WEBPACK_IMPORTED_MODULE_0__/* .useWallet */ .O)(),
      walletType = _useWallet2.walletType;

  var _useAnalytics = (0,_hooks_useAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .useAnalytics */ .z)(),
      track = _useAnalytics.track;

  return function () {
    track('Strategy Created', {
      formName: formName,
      chain: chain,
      address: senderAddress,
      walletType: walletType
    });
  };
}

/***/ }),

/***/ 41799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ invalidateStrategies; },
/* harmony export */   "M": function() { return /* binding */ useStrategies; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50029);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67848);
/* harmony import */ var src_pages_queryClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98392);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6285);
/* harmony import */ var rambda__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98991);
/* harmony import */ var _cosmos_kit_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54056);
/* harmony import */ var _helpers_chains__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87038);
/* harmony import */ var src_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18459);
/* harmony import */ var bech32__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27715);
/* harmony import */ var _useCalcClient_getClient_clients_cosmos__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22606);
/* harmony import */ var _useDenoms__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99867);
/* harmony import */ var _useWallet__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5403);












var QUERY_KEY = 'get_vaults_by_address';
var invalidateStrategies = function invalidateStrategies() {
  return src_pages_queryClient__WEBPACK_IMPORTED_MODULE_1__/* .queryClient.invalidateQueries */ .E.invalidateQueries([QUERY_KEY]);
};
function useStrategies() {
  var _useWallet = (0,_useWallet__WEBPACK_IMPORTED_MODULE_8__/* .useWallet */ .O)(),
      address = _useWallet.address,
      connected = _useWallet.connected;

  var _useDenoms = (0,_useDenoms__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(),
      getDenomById = _useDenoms.getDenomById;

  var chains = (0,rambda__WEBPACK_IMPORTED_MODULE_9__/* .values */ .V)((0,_cosmos_kit_react__WEBPACK_IMPORTED_MODULE_2__/* .useChains */ .C$)(( true ? src_constants__WEBPACK_IMPORTED_MODULE_4__/* .MAINNET_CHAINS */ .ZY : 0).map(_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getChainCosmosName */ .qs)));

  var _useQuery = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_10__/* .useQuery */ .a)(['strategies', address], /*#__PURE__*/(0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2() {
    var fetchStrategies;
    return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchStrategies = /*#__PURE__*/function () {
              var _ref2 = (0,_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)( /*#__PURE__*/_home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(chain) {
                var client, calcClient, userAddress;
                return _home_runner_work_calc_frontend_calc_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return chain.getCosmWasmClient();

                      case 2:
                        client = _context.sent;
                        calcClient = (0,_useCalcClient_getClient_clients_cosmos__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(chain.chain.chain_id, (0,_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getDCAContractAddress */ .cr)(chain.chain.chain_id), client, getDenomById);
                        userAddress = bech32__WEBPACK_IMPORTED_MODULE_5__/* .bech32.encode */ .gW.encode((0,_helpers_chains__WEBPACK_IMPORTED_MODULE_3__/* .getAddressPrefix */ .UF)(chain.chain.chain_id), bech32__WEBPACK_IMPORTED_MODULE_5__/* .bech32.decode */ .gW.decode(address).words);
                        return _context.abrupt("return", calcClient.fetchVaults(userAddress));

                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function fetchStrategies(_x) {
                return _ref2.apply(this, arguments);
              };
            }();

            _context2.t0 = rambda__WEBPACK_IMPORTED_MODULE_12__/* .map */ .UI;

            _context2.t1 = function (result) {
              return result.status === 'fulfilled' ? result.value : [];
            };

            _context2.next = 5;
            return Promise.allSettled(chains.map(fetchStrategies));

          case 5:
            _context2.t2 = _context2.sent;
            return _context2.abrupt("return", (0, _context2.t0)(_context2.t1, _context2.t2).flat());

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), {
    enabled: connected && !!address
  }),
      strategies = _useQuery.data,
      isLoading = _useQuery.isLoading;

  return {
    data: strategies,
    isLoading: isLoading
  };
}

/***/ }),

/***/ 69326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LearnAboutCalcPanel": function() { return /* binding */ LearnAboutCalcPanel; },
  "default": function() { return /* binding */ pages_index_page; }
});

// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-KRPLQIP4.mjs
var chunk_KRPLQIP4 = __webpack_require__(93717);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-ZHMYA64R.mjs + 2 modules
var chunk_ZHMYA64R = __webpack_require__(55281);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-3ASUQ6PA.mjs
var chunk_3ASUQ6PA = __webpack_require__(34292);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chunk-2GBDXOMA.mjs
var chunk_2GBDXOMA = __webpack_require__(36948);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-7OLJDQMT.mjs
var chunk_7OLJDQMT = __webpack_require__(22757);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-7ELO524Q.mjs
var chunk_7ELO524Q = __webpack_require__(47710);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-2OOHT3W5.mjs
var chunk_2OOHT3W5 = __webpack_require__(71293);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-FAWTVNS3.mjs
var chunk_FAWTVNS3 = __webpack_require__(27239);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-W7WUSNWJ.mjs
var chunk_W7WUSNWJ = __webpack_require__(49289);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-PULVB27S.mjs
var chunk_PULVB27S = __webpack_require__(57747);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-NTCQBYKE.mjs
var chunk_NTCQBYKE = __webpack_require__(48783);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chunk-UVUR7MCU.mjs + 3 modules
var chunk_UVUR7MCU = __webpack_require__(93108);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-JARCRF6W.mjs
var chunk_JARCRF6W = __webpack_require__(79078);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-ZPFGWTBB.mjs
var chunk_ZPFGWTBB = __webpack_require__(68519);
// EXTERNAL MODULE: ./src/components/DenomIcon.tsx
var DenomIcon = __webpack_require__(32685);
// EXTERNAL MODULE: ./src/components/Spinner/index.tsx
var Spinner = __webpack_require__(12376);
// EXTERNAL MODULE: ./src/hooks/useAllStrategies.ts
var useAllStrategies = __webpack_require__(74255);
// EXTERNAL MODULE: ./src/utils/getDenomInfo.tsx
var getDenomInfo = __webpack_require__(11599);
// EXTERNAL MODULE: ./src/helpers/strategy/index.ts + 2 modules
var helpers_strategy = __webpack_require__(6686);
// EXTERNAL MODULE: ./src/components/Layout.tsx + 7 modules
var Layout = __webpack_require__(19559);
// EXTERNAL MODULE: ./src/components/LinkWithQuery.tsx
var LinkWithQuery = __webpack_require__(69091);
// EXTERNAL MODULE: ./src/hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(39747);
// EXTERNAL MODULE: ./src/hooks/useStrategies.ts
var useStrategies = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@fusion-icons/react/interface/esm/index.js + 297 modules
var esm = __webpack_require__(52597);
// EXTERNAL MODULE: ./src/hooks/useFiatPrices.ts
var useFiatPrices = __webpack_require__(78719);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/chunk-57I6FYPZ.mjs
var chunk_57I6FYPZ = __webpack_require__(18618);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-DFWC5MHP.mjs
var chunk_DFWC5MHP = __webpack_require__(85970);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-H46NUPBZ.mjs
var chunk_H46NUPBZ = __webpack_require__(5418);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-BL2ZZSHG.mjs
var chunk_BL2ZZSHG = __webpack_require__(65028);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chunk-NEK3OOAM.mjs
var chunk_NEK3OOAM = __webpack_require__(5674);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/form-control/dist/chunk-VGESXGVT.mjs
var chunk_VGESXGVT = __webpack_require__(26105);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/image/dist/chunk-QINAG4RG.mjs + 2 modules
var chunk_QINAG4RG = __webpack_require__(6089);
// EXTERNAL MODULE: ./src/models/DcaInFormData.ts
var DcaInFormData = __webpack_require__(89601);
// EXTERNAL MODULE: ./src/hooks/usePairs.ts
var usePairs = __webpack_require__(5380);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./src/hooks/useValidation.ts
var useValidation = __webpack_require__(62235);
// EXTERNAL MODULE: ./src/hooks/useBalances.ts
var useBalances = __webpack_require__(52560);
// EXTERNAL MODULE: ./src/hooks/useFormStore.ts
var useFormStore = __webpack_require__(48403);
// EXTERNAL MODULE: ./src/models/StrategyType.tsx
var StrategyType = __webpack_require__(94705);
// EXTERNAL MODULE: ./src/components/TransactionType.tsx
var TransactionType = __webpack_require__(95709);
// EXTERNAL MODULE: ./src/formConfig/simpleDcaIn.tsx
var simpleDcaIn = __webpack_require__(2248);
// EXTERNAL MODULE: ./src/hooks/useStrategyInfo.tsx
var useStrategyInfo = __webpack_require__(47134);
// EXTERNAL MODULE: ./src/components/NewStrategyModal/index.tsx + 3 modules
var NewStrategyModal = __webpack_require__(2783);
// EXTERNAL MODULE: ./src/hooks/usePageLoad.ts
var usePageLoad = __webpack_require__(40650);
// EXTERNAL MODULE: ./node_modules/@sentry/react/esm/errorboundary.js + 1 modules
var errorboundary = __webpack_require__(94787);
// EXTERNAL MODULE: ./src/components/Summary/SummaryAgreementForm.tsx
var SummaryAgreementForm = __webpack_require__(18428);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/SuccessStrategyModal.tsx + 1 modules
var SuccessStrategyModal = __webpack_require__(37975);
// EXTERNAL MODULE: ./src/components/DenomSelect.tsx
var DenomSelect = __webpack_require__(75872);
// EXTERNAL MODULE: ./src/helpers/chains/index.ts
var chains = __webpack_require__(87038);
// EXTERNAL MODULE: ./src/hooks/useChainId.ts
var useChainId = __webpack_require__(12680);
// EXTERNAL MODULE: ./src/components/AvailableFunds.tsx
var AvailableFunds = __webpack_require__(24497);
// EXTERNAL MODULE: ./src/components/InitialDeposit.tsx
var InitialDeposit = __webpack_require__(45435);
// EXTERNAL MODULE: ./src/hooks/useSteps.ts
var useSteps = __webpack_require__(27317);
// EXTERNAL MODULE: ./src/utils/totalExecutions.tsx
var totalExecutions = __webpack_require__(66260);
// EXTERNAL MODULE: ./src/helpers/executionIntervalDisplay.tsx
var executionIntervalDisplay = __webpack_require__(63961);
// EXTERNAL MODULE: ./src/helpers/getTimeSaved.tsx
var getTimeSaved = __webpack_require__(84333);
// EXTERNAL MODULE: ./src/helpers/format/formatFiat.tsx
var formatFiat = __webpack_require__(50215);
// EXTERNAL MODULE: ./src/hooks/useWallet.ts
var useWallet = __webpack_require__(5403);
// EXTERNAL MODULE: ./src/hooks/useDenoms.ts
var useDenoms = __webpack_require__(99867);
// EXTERNAL MODULE: ./node_modules/react-router-dom/dist/index.js
var dist = __webpack_require__(79655);
// EXTERNAL MODULE: ./node_modules/rambda/src/values.js
var values = __webpack_require__(6285);
// EXTERNAL MODULE: ./src/hooks/useRoute.ts
var useRoute = __webpack_require__(61456);
// EXTERNAL MODULE: ./node_modules/@cosmjs/stargate/build/index.js
var build = __webpack_require__(24658);
// EXTERNAL MODULE: ./src/hooks/useQueryState.ts
var useQueryState = __webpack_require__(9397);
// EXTERNAL MODULE: ./src/hooks/useCreateVault/useCreateVaultDca/index.ts
var useCreateVaultDca = __webpack_require__(11247);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/radio/dist/chunk-Q56JAA3U.mjs
var chunk_Q56JAA3U = __webpack_require__(20307);
;// CONCATENATED MODULE: ./src/helpers/executionIntervalData.tsx
var executionIntervalData = [{
  value: 'hourly',
  label: 'Hour'
}, {
  value: 'daily',
  label: 'Day'
}, {
  value: 'weekly',
  label: 'Week'
}, {
  value: 'monthly',
  label: 'Month'
}];
// EXTERNAL MODULE: ./src/components/Radio.tsx
var Radio = __webpack_require__(39233);
// EXTERNAL MODULE: ./src/components/RadioCard.tsx
var RadioCard = __webpack_require__(9126);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/ExecutionIntervalLegacy.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








function ExecutionIntervalLegacy() {
  var _useField = (0,formik_esm/* useField */.U$)({
    name: 'executionInterval'
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      field = _useField2[0],
      helpers = _useField2[2];

  var _useField3 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField4 = (0,slicedToArray/* default */.Z)(_useField3, 1),
      resultingDenom = _useField4[0].value;

  var _useRadioGroup = (0,chunk_Q56JAA3U/* useRadioGroup */.a)(_objectSpread(_objectSpread({}, field), {}, {
    defaultValue: 'daily',
    onChange: helpers.setValue
  })),
      getRootProps = _useRadioGroup.getRootProps,
      getRadioProps = _useRadioGroup.getRadioProps;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormControl */.NI, {
    isDisabled: !resultingDenom,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_H46NUPBZ/* FormLabel */.l, {
      children: "Every:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Radio/* default */.Z, _objectSpread(_objectSpread({}, getRootProps), {}, {
      children: executionIntervalData.map(function (option) {
        var radio = getRadioProps({
          value: option.value
        });
        return /*#__PURE__*/(0,jsx_runtime.jsx)(RadioCard/* default */.Z, _objectSpread(_objectSpread({
          textAlign: "center"
        }, radio), {}, {
          isDisabled: !resultingDenom,
          children: option.label
        }), option.label);
      })
    }))]
  });
}
// EXTERNAL MODULE: ./src/components/DenomInput.tsx
var DenomInput = __webpack_require__(21964);
// EXTERNAL MODULE: ./src/components/ConnectWalletButton.tsx
var ConnectWalletButton = __webpack_require__(47309);
;// CONCATENATED MODULE: ./src/components/SimpleDcaInForm.tsx




var _excluded = ["onChange", "value"];


function SimpleDcaInForm_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function SimpleDcaInForm_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? SimpleDcaInForm_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : SimpleDcaInForm_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












































function ModalHeader(_ref) {
  var isSuccess = _ref.isSuccess;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
    size: "sm",
    children: isSuccess ? 'Strategy successfully created!' : 'Setup a simple dollar cost averaging (DCA) strategy'
  });
}

function InitialDenom() {
  var _denoms$chainId, _initialDenom$value, _initialDenom$value2;

  var _usePairs = (0,usePairs/* default */.ZP)(),
      pairs = _usePairs.pairs;

  var _useDenoms = (0,useDenoms/* default */.Z)(),
      getDenomById = _useDenoms.getDenomById,
      denoms = _useDenoms.denoms;

  var _useChainId = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId.chainId;

  var _useField = (0,formik_esm/* useField */.U$)({
    name: 'initialDenom'
  }),
      _useField2 = (0,slicedToArray/* default */.Z)(_useField, 3),
      initialDenom = _useField2[0],
      meta = _useField2[1],
      initialDenomHelpers = _useField2[2];

  var _useField3 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField4 = (0,slicedToArray/* default */.Z)(_useField3, 3),
      resultingDenomHelpers = _useField4[2];

  var _useMediaQuery = (0,chunk_57I6FYPZ/* useMediaQuery */.a)('(max-width: 506px)'),
      _useMediaQuery2 = (0,slicedToArray/* default */.Z)(_useMediaQuery, 1),
      isMobile = _useMediaQuery2[0];

  (0,react.useEffect)(function () {
    if (!!pairs && pairs.length > 0 && !initialDenom.value) {
      var randomPair = pairs[Math.floor(Math.random() * pairs.length)];
      initialDenomHelpers.setValue(randomPair.denoms[0]);
      resultingDenomHelpers.setValue(randomPair.denoms[1]);
    }
  });
  if (!pairs) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormControl */.NI, {
    isInvalid: Boolean(meta.touched && meta.error),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_H46NUPBZ/* FormLabel */.l, {
      children: "Using:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_DFWC5MHP/* FormHelperText */.Q6, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_FAWTVNS3/* Center */.M, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
          textStyle: "body-xs",
          children: "Choose asset to sell"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_BL2ZZSHG/* Spacer */.L, {}), initialDenom.value && /*#__PURE__*/(0,jsx_runtime.jsx)(AvailableFunds/* AvailableFunds */.jk, {
          denom: initialDenom.value
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_NEK3OOAM/* SimpleGrid */.M, {
      columns: 2,
      spacing: 2,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_PULVB27S/* Box */.xu, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DenomSelect/* DenomSelect */.a, {
          denoms: (0,usePairs/* orderAlphabetically */.t1)((0,values/* values */.V)((_denoms$chainId = denoms === null || denoms === void 0 ? void 0 : denoms[chainId]) !== null && _denoms$chainId !== void 0 ? _denoms$chainId : {})),
          placeholder: isMobile ? 'Asset' : 'Choose asset',
          defaultValue: (_initialDenom$value = initialDenom.value) === null || _initialDenom$value === void 0 ? void 0 : _initialDenom$value.id,
          value: (_initialDenom$value2 = initialDenom.value) === null || _initialDenom$value2 === void 0 ? void 0 : _initialDenom$value2.id,
          onChange: function onChange(newValue) {
            if (!newValue) return;
            initialDenomHelpers.setValue(getDenomById(newValue));
            resultingDenomHelpers.setValue(undefined);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_VGESXGVT/* FormErrorMessage */.J1, {
          children: meta.touched && meta.error
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InitialDeposit/* default */.Z, {})]
    })]
  });
}

function ResultingDenom(_ref2) {
  var denoms = _ref2.denoms;

  var _useField5 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField6 = (0,slicedToArray/* default */.Z)(_useField5, 3),
      resultingDenom = _useField6[0].value,
      meta = _useField6[1],
      helpers = _useField6[2];

  var _useChainId2 = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId2.chainId;

  var _useDenoms2 = (0,useDenoms/* default */.Z)(),
      getDenomById = _useDenoms2.getDenomById;

  var _useFormikContext = (0,formik_esm/* useFormikContext */.u6)(),
      initialDenom = _useFormikContext.values.initialDenom;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormControl */.NI, {
    isInvalid: Boolean(meta.touched && meta.error),
    isDisabled: !initialDenom,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_H46NUPBZ/* FormLabel */.l, {
      children: "I want to DCA into:"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_DFWC5MHP/* FormHelperText */.Q6, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
        textStyle: "body-xs",
        children: "CALC will purchase this asset for you"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DenomSelect/* DenomSelect */.a, {
      denoms: denoms,
      placeholder: "Choose asset",
      defaultValue: resultingDenom === null || resultingDenom === void 0 ? void 0 : resultingDenom.id,
      value: resultingDenom === null || resultingDenom === void 0 ? void 0 : resultingDenom.id,
      onChange: function onChange(v) {
        return v && helpers.setValue(getDenomById(v));
      },
      optionLabel: "Swapped on ".concat((0,chains/* getChainDexName */.rB)(chainId))
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_VGESXGVT/* FormErrorMessage */.J1, {
      children: meta.touched && meta.error
    })]
  });
}

function SwapAmount(_ref3) {
  var _fromAtomic$toLocaleS;

  var initialDenom = _ref3.initialDenom,
      resultingDenom = _ref3.resultingDenom;

  var _useChainId3 = (0,useChainId/* useChainId */.x)(),
      chainId = _useChainId3.chainId;

  var _useField7 = (0,formik_esm/* useField */.U$)({
    name: 'swapAmount'
  }),
      _useField8 = (0,slicedToArray/* default */.Z)(_useField7, 3),
      _useField8$ = _useField8[0],
      onChange = _useField8$.onChange,
      swapAmount = _useField8$.value,
      swapAmountField = (0,objectWithoutProperties/* default */.Z)(_useField8$, _excluded),
      swapAmountMeta = _useField8[1],
      setSwapAmount = _useField8[2].setValue;

  var _useField9 = (0,formik_esm/* useField */.U$)({
    name: 'initialDeposit'
  }),
      _useField10 = (0,slicedToArray/* default */.Z)(_useField9, 2),
      initialDeposit = _useField10[0].value,
      depositMeta = _useField10[1];

  var _useField11 = (0,formik_esm/* useField */.U$)({
    name: 'executionInterval'
  }),
      _useField12 = (0,slicedToArray/* default */.Z)(_useField11, 1),
      executionInterval = _useField12[0].value;

  var _useField13 = (0,formik_esm/* useField */.U$)({
    name: 'route'
  }),
      _useField14 = (0,slicedToArray/* default */.Z)(_useField13, 3),
      routeMeta = _useField14[1],
      routeHelpers = _useField14[2];

  var executions = initialDeposit && swapAmount ? (0,totalExecutions/* default */.Z)(initialDeposit, swapAmount) : 0;
  var displayExecutionInterval = executionInterval && executions > 0 && executionIntervalDisplay/* default */.Z[executionInterval][executions > 1 ? 1 : 0];

  var _useRoute = (0,useRoute/* default */.Z)(swapAmount && initialDenom ? (0,build.coin)(BigInt(swapAmount).toString(), initialDenom.id) : undefined, resultingDenom),
      route = _useRoute.route,
      routeError = _useRoute.routeError,
      routeIsLoading = _useRoute.isLoading;

  (0,react.useEffect)(function () {
    if (routeIsLoading) {
      routeHelpers.setValue(undefined);
      routeHelpers.setTouched(false);
    } else if (routeError) {
      routeHelpers.setTouched(true, false);
      routeHelpers.setError(routeError);
    } else {
      routeHelpers.setValue(route);
      routeHelpers.setTouched(true);
    }
  }, [route, routeError, routeIsLoading]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormControl */.NI, {
    isInvalid: Boolean(swapAmountMeta.touched && swapAmountMeta.error && initialDeposit) || Boolean(routeMeta.touched && routeError),
    isDisabled: !executionInterval || !initialDeposit,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_H46NUPBZ/* FormLabel */.l, {
      children: ["How much ", initialDenom === null || initialDenom === void 0 ? void 0 : initialDenom.name, " each purchase?"]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormHelperText */.Q6, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
        alignItems: "flex-start",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_2OOHT3W5/* Text */.x, {
          children: ["The amount you want swapped each purchase for ", resultingDenom === null || resultingDenom === void 0 ? void 0 : resultingDenom.name, "."]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_BL2ZZSHG/* Spacer */.L, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
          flexDirection: "row",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
            ml: 4,
            mr: 1,
            children: "Max:"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_UVUR7MCU/* Button */.z, {
            size: "xs",
            colorScheme: "blue",
            variant: "link",
            cursor: "pointer",
            onClick: function onClick() {
              return setSwapAmount(initialDeposit);
            },
            children: initialDenom && initialDeposit && depositMeta.touched ? (_fromAtomic$toLocaleS = (0,getDenomInfo/* fromAtomic */.b1)(initialDenom, initialDeposit).toLocaleString('en-US', {
              maximumFractionDigits: 6,
              minimumFractionDigits: 2
            })) !== null && _fromAtomic$toLocaleS !== void 0 ? _fromAtomic$toLocaleS : '-' : '-'
          })]
        })]
      }), ' ']
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DenomInput/* DenomInput */.h, SimpleDcaInForm_objectSpread(SimpleDcaInForm_objectSpread({
      denom: initialDenom,
      onChange: function onChange(input) {
        return initialDenom && setSwapAmount((0,getDenomInfo/* toAtomic */.Iy)(initialDenom, input !== null && input !== void 0 ? input : 0));
      },
      value: initialDenom && swapAmount && (0,getDenomInfo/* fromAtomic */.b1)(initialDenom, swapAmount)
    }, swapAmountField), {}, {
      isDisabled: !initialDeposit
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormHelperText */.Q6, {
      children: ["Swap amount must be greater than ", (0,formatFiat/* formatFiat */.M)((0,chains/* getChainMinimumSwapValue */.Jd)(chainId))]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_VGESXGVT/* FormErrorMessage */.J1, {
      children: routeError || swapAmountMeta.error
    }), initialDeposit && !depositMeta.error && depositMeta.touched && swapAmount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_DFWC5MHP/* FormHelperText */.Q6, {
      color: "brand.200",
      fontSize: "xs",
      children: ["A total of ", executions, " swaps will take place over ", executions, " ", displayExecutionInterval, "."]
    })]
  });
}

function SimpleDCAInForm(_ref4) {
  var formValues = _ref4.formValues;

  var _useWallet = (0,useWallet/* useWallet */.O)(),
      connected = _useWallet.connected;

  var _useSteps = (0,useSteps/* default */.Z)(simpleDcaIn/* default */.Z),
      nextStep = _useSteps.nextStep;

  var _useCreateVaultDca = (0,useCreateVaultDca/* useCreateVaultDca */.E)(),
      mutate = _useCreateVaultDca.mutate,
      isError = _useCreateVaultDca.isError,
      error = _useCreateVaultDca.error,
      isLoading = _useCreateVaultDca.isLoading;

  var _usePairs2 = (0,usePairs/* default */.ZP)(),
      pairs = _usePairs2.pairs;

  var _usePageLoad = (0,usePageLoad/* default */.Z)(),
      isPageLoading = _usePageLoad.isPageLoading;

  var _useState = (0,react.useState)(false),
      isSuccess = _useState[0],
      setIsSuccess = _useState[1];

  var _useField15 = (0,formik_esm/* useField */.U$)({
    name: 'initialDenom'
  }),
      _useField16 = (0,slicedToArray/* default */.Z)(_useField15, 1),
      initialDenom = _useField16[0].value;

  var _useField17 = (0,formik_esm/* useField */.U$)({
    name: 'initialDeposit'
  }),
      _useField18 = (0,slicedToArray/* default */.Z)(_useField17, 2),
      initialDepositMeta = _useField18[1];

  var _useField19 = (0,formik_esm/* useField */.U$)({
    name: 'resultingDenom'
  }),
      _useField20 = (0,slicedToArray/* default */.Z)(_useField19, 1),
      resultingDenom = _useField20[0].value;

  var _useField21 = (0,formik_esm/* useField */.U$)({
    name: 'route'
  }),
      _useField22 = (0,slicedToArray/* default */.Z)(_useField21, 2),
      routeMeta = _useField22[1];

  var _useQueryState = (0,useQueryState/* default */.Z)(),
      _useQueryState2 = (0,slicedToArray/* default */.Z)(_useQueryState, 2),
      setQueryState = _useQueryState2[1];

  var handleSubmit = function handleSubmit(_, _ref5, state) {
    var setSubmitting = _ref5.setSubmitting;
    return mutate({
      state: state
    }, {
      onSuccess: function () {
        var _onSuccess = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(strategyId) {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  nextStep({
                    strategyId: strategyId,
                    timeSaved: state && (0,getTimeSaved/* getTimeSaved */.a)(state.initialDeposit, state.swapAmount)
                  });
                  setQueryState({
                    strategyId: strategyId,
                    timeSaved: state && (0,getTimeSaved/* getTimeSaved */.a)(state.initialDeposit, state.swapAmount)
                  });
                  setIsSuccess(true);

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function onSuccess(_x) {
          return _onSuccess.apply(this, arguments);
        }

        return onSuccess;
      }(),
      onSettled: function onSettled() {
        setSubmitting(false);
      }
    });
  };

  if (!pairs) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_FAWTVNS3/* Center */.M, {
      h: 56,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
    });
  }

  var resultingDenoms = initialDenom ? (0,usePairs/* getResultingDenoms */.jS)(pairs, initialDenom).filter(function (denom) {
    return denom.id !== (initialDenom === null || initialDenom === void 0 ? void 0 : initialDenom.id);
  }) : [];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_KRPLQIP4/* Flex */.k, {
    layerStyle: "panel",
    p: {
      base: 0,
      sm: 4
    },
    alignItems: "center",
    justifyContent: "center",
    h: "full",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_PULVB27S/* Box */.xu, {
      maxWidth: 451,
      mx: "auto",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewStrategyModal/* NewStrategyModalBody */.p9, {
        stepsConfig: simpleDcaIn/* default */.Z,
        isLoading: isPageLoading,
        isSigning: isLoading,
        children: isSuccess ? /*#__PURE__*/(0,jsx_runtime.jsx)(SuccessStrategyModal/* SuccessStrategyModalBody */.S, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
          direction: "column",
          spacing: 4,
          visibility: isLoading ? 'hidden' : 'visible',
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ModalHeader, {
            isSuccess: isSuccess
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(InitialDenom, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ResultingDenom, {
            denoms: resultingDenoms
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ExecutionIntervalLegacy, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(SwapAmount, {
            initialDenom: initialDenom,
            resultingDenom: resultingDenom
          }), connected ? /*#__PURE__*/(0,jsx_runtime.jsx)(SummaryAgreementForm/* SummaryAgreementForm */.I, {
            isError: isError,
            error: error,
            onSubmit: function onSubmit(agreementData, setSubmitting) {
              return handleSubmit(agreementData, setSubmitting, formValues);
            },
            isDisabled: !routeMeta.touched || !!routeMeta.error || !initialDepositMeta.touched || !!initialDepositMeta.error
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ConnectWalletButton/* ConnectWalletButton */.p, {})]
        })
      })
    })
  });
}

function SimpleDcaIn() {
  var _useBalances = (0,useBalances/* default */.Z)(),
      balances = _useBalances.balances;

  var _useValidation = (0,useValidation/* default */.Z)(DcaInFormData/* simplifiedDcaInValidationSchema */.oP, {
    balances: balances
  }),
      validate = _useValidation.validate;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(useStrategyInfo/* StrategyInfoProvider */.cS, {
    strategyInfo: {
      strategyType: StrategyType/* StrategyType.SimpleDCAIn */.h.SimpleDCAIn,
      transactionType: TransactionType/* TransactionType.Buy */.i.Buy,
      formName: useFormStore/* FormNames.SimpleDcaIn */.Z.SimpleDcaIn
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(dist/* BrowserRouter */.VK, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
        initialValues: DcaInFormData/* initialValues */.Sc,
        validate: validate,
        onSubmit: function onSubmit() {},
        children: function children(_ref6) {
          var formValues = _ref6.values;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(errorboundary/* ErrorBoundary */.SV, {
            fallback: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_FAWTVNS3/* Center */.M, {
              m: 8,
              p: 8,
              flexDirection: "column",
              gap: 6,
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
                size: "lg",
                children: "Something went wrong"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_QINAG4RG/* Image */.E, {
                w: 28,
                h: 28,
                src: "/images/notConnected.png"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                children: "Please try again in a new session"
              })]
            }),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(SimpleDCAInForm, {
              formValues: formValues
            })
          });
        }
      })
    })
  });
}
// EXTERNAL MODULE: ./src/pages/stats-and-totals/index.page.tsx
var index_page = __webpack_require__(49259);
;// CONCATENATED MODULE: ./src/pages/index.page.tsx




















var isStrategyAccumulating = function isStrategyAccumulating(strategy) {
  return (0,getDenomInfo/* isDenomStable */.dG)((0,helpers_strategy/* getStrategyInitialDenom */.vB)(strategy));
};

var isStrategyProfitTaking = function isStrategyProfitTaking(strategy) {
  return (0,getDenomInfo/* isDenomVolatile */.g1)((0,helpers_strategy/* getStrategyInitialDenom */.vB)(strategy));
};

function InvestmentThesisWithActiveStrategies(_ref) {
  var _strategies$filter;

  var strategies = _ref.strategies,
      isLoading = _ref.isLoading;
  var activeStrategies = (_strategies$filter = strategies === null || strategies === void 0 ? void 0 : strategies.filter(helpers_strategy/* isStrategyOperating */.KF)) !== null && _strategies$filter !== void 0 ? _strategies$filter : [];
  var accumulatingAssets = Array.from(new Set(activeStrategies.filter(isStrategyAccumulating).map(function (strategy) {
    return strategy.resultingDenom;
  })));
  var profitTakingAssets = Array.from(new Set(activeStrategies.filter(isStrategyProfitTaking).map(function (strategy) {
    return strategy.initialDenom;
  })));
  return /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_KRPLQIP4/* Flex */.k, {
    layerStyle: "panel",
    p: 8,
    alignItems: "center",
    h: "full",
    children: isLoading ? /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
      spacing: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_3ASUQ6PA/* HStack */.U, {
        spacing: 2,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2GBDXOMA/* Icon */.J, {
          as: esm/* CrownIcon */.CEn,
          stroke: "blue.200",
          strokeWidth: 5,
          w: 6,
          h: 6
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
          size: "md",
          children: "My investment thesis:"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
        direction: "row",
        gap: 8,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
          direction: "column",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
            size: "xs",
            textColor: "gray.200",
            children: "My active CALC strategies:"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_7OLJDQMT/* Heading */.X, {
            size: "2xl",
            children: [" ", activeStrategies.length]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
          spacing: 6,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_7ELO524Q/* Wrap */.E, {
            spacingX: 6,
            spacingY: 2,
            align: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
              children: "Asset(s) accumulating:"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_3ASUQ6PA/* HStack */.U, {
              children: accumulatingAssets.length ? accumulatingAssets.map(function (asset) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(DenomIcon/* default */.Z, {
                  size: 6,
                  showTooltip: true,
                  denomInfo: asset
                }, asset.id);
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                children: "-"
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_7ELO524Q/* Wrap */.E, {
            spacingX: 6,
            spacingY: 2,
            align: "center",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
              children: "Asset(s) taking profit on:"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_3ASUQ6PA/* HStack */.U, {
              children: profitTakingAssets.length ? profitTakingAssets.map(function (asset) {
                return /*#__PURE__*/(0,jsx_runtime.jsx)(DenomIcon/* default */.Z, {
                  size: 6,
                  showTooltip: true,
                  denomInfo: asset
                }, asset.id);
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
                children: "-"
              })
            })]
          })]
        })]
      })]
    })
  });
}

function TotalInvestment() {
  var _useDenoms = (0,useDenoms/* default */.Z)(),
      allDenoms = _useDenoms.allDenoms;

  var _useFiatPrices = (0,useFiatPrices/* default */.Z)(),
      fiatPrices = _useFiatPrices.fiatPrices;

  var _useAllStrategies = (0,useAllStrategies/* default */.Z)(),
      strategies = _useAllStrategies.strategies;

  if (!fiatPrices || !strategies || !allDenoms) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_FAWTVNS3/* Center */.M, {
      layerStyle: "panel",
      p: 8,
      h: "full",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Spinner/* default */.Z, {})
    });
  }

  var totalSwappedAmounts = (0,index_page.getTotalSwapped)(strategies, (0,values/* values */.V)(allDenoms !== null && allDenoms !== void 0 ? allDenoms : {}));
  var totalSwappedTotal = (0,index_page.totalFromCoins)(allDenoms, totalSwappedAmounts, fiatPrices);
  var formattedValue = totalSwappedTotal >= 1000000 ? "$".concat((totalSwappedTotal / 1000000).toFixed(3), "m") : "$".concat(Math.floor(totalSwappedTotal / 1000), "k");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
    layerStyle: "panel",
    p: 8,
    h: "full",
    spacing: 6,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_3ASUQ6PA/* HStack */.U, {
      spacing: 2,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2GBDXOMA/* Icon */.J, {
        as: esm/* DropIcon */.rsV,
        stroke: "blue.200",
        strokeWidth: 5,
        w: 6,
        h: 6
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
        size: "md",
        children: "How much is CALC reducing stress and saving time?"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_KRPLQIP4/* Flex */.k, {
      gap: 12,
      direction: ['column', null, 'row'],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZHMYA64R/* Stack */.K, {
        spacing: 4,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_7OLJDQMT/* Heading */.X, {
          "data-testid": "active-strategy-count",
          fontSize: "5xl",
          children: [strategies.length, /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
            fontSize: "md",
            children: "total strategies created"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_W7WUSNWJ/* Divider */.i, {
        display: ['none', null, 'flex'],
        orientation: "vertical"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_W7WUSNWJ/* Divider */.i, {
        display: ['flex', null, 'none']
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZHMYA64R/* Stack */.K, {
        spacing: 4,
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_7OLJDQMT/* Heading */.X, {
          "data-testid": "active-strategy-count",
          fontSize: "5xl",
          children: [formattedValue, /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
            fontSize: "md",
            children: "total swapped (USD)"
          })]
        })
      })]
    })]
  });
}

function LearnAboutCalcPanel() {
  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      track = _useAnalytics.track;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_PULVB27S/* Box */.xu, {
    layerStyle: "panel",
    p: 8,
    backgroundImage: "/images/backgrounds/twist-thin-blue.svg",
    backgroundSize: "cover",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_NTCQBYKE/* VStack */.g, {
      alignItems: "left",
      spacing: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_3ASUQ6PA/* HStack */.U, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2GBDXOMA/* Icon */.J, {
          as: esm/* KnowledgeIcon */.jSc,
          stroke: "blue.200",
          strokeWidth: 5,
          w: 6,
          h: 6
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
          size: "md",
          children: "New to CALC?"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_ZHMYA64R/* Stack */.K, {
        spacing: 1,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
          fontSize: "sm",
          children: "Find out why people are raving about their experiences leveraging CALC to make smarter swaps."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
          fontSize: "sm",
          textStyle: "body",
          children: "DCA | DCA+ | Weighted Scale"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZHMYA64R/* Stack */.K, {
        direction: {
          base: 'column',
          sm: 'row'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkWithQuery/* default */.Z, {
          passHref: true,
          href: "/learn-about-calc",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_UVUR7MCU/* Button */.z, {
            px: 12,
            maxWidth: 402,
            size: "sm",
            bgColor: "blue.200",
            _hover: {
              bgColor: 'blue.300'
            },
            onClick: function onClick() {
              return track('Learning hub button clicked');
            },
            children: "Learn how CALC works"
          })
        })
      })]
    })
  });
}

function HomeGrid() {
  var _strategies$filter2;

  var _useStrategies = (0,useStrategies/* useStrategies */.M)(),
      strategies = _useStrategies.data,
      isLoading = _useStrategies.isLoading;

  var activeStrategies = (_strategies$filter2 = strategies === null || strategies === void 0 ? void 0 : strategies.filter(helpers_strategy/* isStrategyOperating */.KF)) !== null && _strategies$filter2 !== void 0 ? _strategies$filter2 : [];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_JARCRF6W/* Grid */.r, {
    gap: 4,
    templateColumns: "repeat(10, 1fr)",
    templateRows: "repeat(3, 1fr)",
    alignItems: "stretch",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZPFGWTBB/* GridItem */.P, {
      colSpan: [10, 10, 10, 10, 5, 5],
      rowSpan: 3,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SimpleDcaIn, {})
    }), Boolean(activeStrategies.length) && /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZPFGWTBB/* GridItem */.P, {
      colSpan: [10, 10, 10, 10, 5, 5],
      rowSpan: 1,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(InvestmentThesisWithActiveStrategies, {
        strategies: strategies,
        isLoading: isLoading
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZPFGWTBB/* GridItem */.P, {
      colSpan: [10, 10, 10, 10, 5, 5],
      rowSpan: 1,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(TotalInvestment, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_ZPFGWTBB/* GridItem */.P, {
      colSpan: [10, 10, 10, 10, 5, 5],
      rowSpan: 1,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LearnAboutCalcPanel, {})
    })]
  });
}

function Home() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(chunk_PULVB27S/* Box */.xu, {
      pb: 8,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(chunk_7OLJDQMT/* Heading */.X, {
        size: "lg",
        mb: 2,
        children: "Welcome to CALC, you've made a great choice!"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(chunk_2OOHT3W5/* Text */.x, {
        textStyle: "body",
        children: "Stop being glued to a computer screen 24/7, define your strategy up front, and leave the rest to CALC."
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeGrid, {})]
  });
}

Home.getLayout = Layout/* getSidebarLayout */.M;
/* harmony default export */ var pages_index_page = (Home);

/***/ }),

/***/ 89208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(69326);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9048,296,6189,78,1879,9150,5625,3849,4644,2677,6170,9473,7333,4391,2321,9509,2812,2297,8345,397,3258,7975,4291,9259,9774,2888,179], function() { return __webpack_exec__(89208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);